import { ApplicationConfig, importProvidersFrom, Injectable, inject, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, HTTP_INTERCEPTORS, withInterceptorsFromDi, HttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

// Third-party modules
import { YouTubePlayerModule } from '@angular/youtube-player';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { GoogleMapsModule } from '@angular/google-maps';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { NgxEditorModule } from 'ngx-editor';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { LeafletModule } from '@bluehalo/ngx-leaflet';

// Routing
import { appRoutes } from './app.routes';

// Interceptors
import { AuthInterceptor } from './components/auth.interceptor';

// Organization interceptor
import { OrganizationInterceptor } from './components/organization.interceptor';

// Global modules
import { ValidateFormComponent } from './modules/validate-form/validate-form.component';
import { ServerServerValidateFormComponent } from './modules/server-validation/server-validation-form.component';
import { GlobalNumberStepperService } from './services/global-number-stepper.service';

@Injectable()
export class TranslationLoader implements TranslateLoader {
  constructor(private http: HttpClient) { }
  getTranslation(lang: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}translations/${lang}`);
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslationLoader(http); // To load from DB
  //return new TranslateHttpLoader(http, './assets/i18n/', '.json'); // To load from For local file
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    provideAnimations(),
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    // Legacy interceptor support
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OrganizationInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    
    // Import third-party modules
    importProvidersFrom([
      YouTubePlayerModule,
      DragDropModule,
      ScrollingModule,
      GoogleMapsModule,
      CarouselModule,
      NgxEditorModule,
      ModalModule,
      NgxMaterialTimepickerModule,
      LeafletModule,
      // TranslateModule for i18n
      TranslateModule.forRoot({
        fallbackLang: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    ]),
    
    // Global components available everywhere
    ValidateFormComponent,
    ServerServerValidateFormComponent,
    provideAppInitializer(() => inject(GlobalNumberStepperService).init()),
  ],
};
